export const Titulo = ({ bloque }) => {
    return (<><div className={bloque.datos.size}>{bloque.datos.texto}</div></>);
};


export default Titulo;